import React from 'react';

const MaterialUIComponentsRoutes = [
	{
		path: '/documentation/material-ui-components/alert',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Alert'))
	},
	{
		path: '/documentation/material-ui-components/app-bar',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/AppBar'))
	},
	{
		path: '/documentation/material-ui-components/autocomplete',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Autocomplete'))
	},
	{
		path: '/documentation/material-ui-components/avatars',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Avatars'))
	},
	{
		path: '/documentation/material-ui-components/backdrop',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Backdrop'))
	},
	{
		path: '/documentation/material-ui-components/badges',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Badges'))
	},
	{
		path: '/documentation/material-ui-components/bottom-navigation',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/BottomNavigation'))
	},
	{
		path: '/documentation/material-ui-components/box',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Box'))
	},
	{
		path: '/documentation/material-ui-components/breadcrumbs',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Breadcrumbs'))
	},
	{
		path: '/documentation/material-ui-components/button-group',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/ButtonGroup'))
	},
	{
		path: '/documentation/material-ui-components/buttons',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Buttons'))
	},
	{
		path: '/documentation/material-ui-components/cards',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Cards'))
	},
	{
		path: '/documentation/material-ui-components/checkboxes',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Checkboxes'))
	},
	{
		path: '/documentation/material-ui-components/chips',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Chips'))
	},
	{
		path: '/documentation/material-ui-components/click-away-listener',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/ClickAwayListener'))
	},
	{
		path: '/documentation/material-ui-components/container',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Container'))
	},
	{
		path: '/documentation/material-ui-components/css-baseline',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/CssBaseline'))
	},
	{
		path: '/documentation/material-ui-components/dialogs',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Dialogs'))
	},
	{
		path: '/documentation/material-ui-components/dividers',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Dividers'))
	},
	{
		path: '/documentation/material-ui-components/drawers',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Drawers'))
	},
	{
		path: '/documentation/material-ui-components/expansion-panels',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/ExpansionPanels'))
	},
	{
		path: '/documentation/material-ui-components/floating-action-button',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/FloatingActionButton'))
	},
	{
		path: '/documentation/material-ui-components/grid',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Grid'))
	},
	{
		path: '/documentation/material-ui-components/grid-list',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/GridList'))
	},
	{
		path: '/documentation/material-ui-components/hidden',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Hidden'))
	},
	{
		path: '/documentation/material-ui-components/links',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Links'))
	},
	{
		path: '/documentation/material-ui-components/lists',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Lists'))
	},
	{
		path: '/documentation/material-ui-components/menus',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Menus'))
	},
	{
		path: '/documentation/material-ui-components/modal',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Modal'))
	},
	{
		path: '/documentation/material-ui-components/no-ssr',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/NoSsr'))
	},
	{
		path: '/documentation/material-ui-components/pagination',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Pagination'))
	},
	{
		path: '/documentation/material-ui-components/paper',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Paper'))
	},
	{
		path: '/documentation/material-ui-components/pickers',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Pickers'))
	},
	{
		path: '/documentation/material-ui-components/popover',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Popover'))
	},
	{
		path: '/documentation/material-ui-components/popper',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Popper'))
	},
	{
		path: '/documentation/material-ui-components/portal',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Portal'))
	},
	{
		path: '/documentation/material-ui-components/progress',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Progress'))
	},
	{
		path: '/documentation/material-ui-components/radio-buttons',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/RadioButtons'))
	},
	{
		path: '/documentation/material-ui-components/selects',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Selects'))
	},
	{
		path: '/documentation/material-ui-components/slider',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Slider'))
	},
	{
		path: '/documentation/material-ui-components/snackbars',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Snackbars'))
	},
	{
		path: '/documentation/material-ui-components/steppers',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Steppers'))
	},
	{
		path: '/documentation/material-ui-components/switches',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Switches'))
	},
	{
		path: '/documentation/material-ui-components/tables',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Tables'))
	},
	{
		path: '/documentation/material-ui-components/tabs',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Tabs'))
	},
	{
		path: '/documentation/material-ui-components/text-fields',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/TextFields'))
	},
	{
		path: '/documentation/material-ui-components/textarea-autosize',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/TextareaAutosize'))
	},
	{
		path: '/documentation/material-ui-components/tooltips',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Tooltips'))
	},
	{
		path: '/documentation/material-ui-components/transfer-list',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/TransferList'))
	},
	{
		path: '/documentation/material-ui-components/transitions',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Transitions'))
	},
	{
		path: '/documentation/material-ui-components/typography',
		component: React.lazy(() => import('app/main/documentation/material-ui-components/pages/Typography'))
	}
];

export default MaterialUIComponentsRoutes;
